import React from "react";
import { Table } from "react-bootstrap";
import NoDataFound from "../../../../components/NoDataFound";
import { TbPackages } from "react-icons/tb";

const WorkPackageTable = ({ workpackages, columns }) => {
  return (
    <>
      {workpackages.length > 0 ? (
        <Table responsive>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.accessor}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {workpackages?.map((wp) => (
              <tr key={wp._id}>
                {columns.map((col) => (
                  <td key={col.accessor}>
                    {col.cell ? col.cell(wp) : wp[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <NoDataFound
          icon={<TbPackages size={50} />}
          title="Work Packages not found"
          description="Try Ask to add some work packages."
        />
      )}
    </>
  );
};

export default WorkPackageTable;
